__turbopack_context__.v({
  "container": "bread_crumb-module-scss-module__9T9DwW__container",
});
